import React, { useState } from "react";
import "./Recon.css";
import { createBlockedUsers, createRecon } from "../../../config/LiveApi";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import DownloadExcel from "./DownloadExcel";

const SelectedTransactions = ({ addedDataForRecon }) => {
  let token = useSelector((store) => store.userReducer.token);

  const [transactions, setTransactions] = useState(
    addedDataForRecon.map((transaction) => ({
      ...transaction,
      approved: false,
    }))
  );

  const approveTransaction = async (transactionIndex) => {
    try {
      const transaction = transactions[transactionIndex];
  
      const fraudDetectionData = {
        userId: transaction?.userId,
        name: transaction?.dataItem?.customerName,
        email: transaction?.dataItem?.customerEmail,
        phoneNumber: transaction?.dataItem?.customerMobile,
        accountNumber: transaction?.dataItem?.accountNumber || '',
        ifsc: transaction?.dataItem?.ifscCode || '',
        vpa: transaction.dataItem.vpa || '',
      };
  
      // Block user - don't stop execution if it fails
      try {
        const blockedUserResponse = await createBlockedUsers(fraudDetectionData);
        if (blockedUserResponse) {
          toast.success("User added to fraud detection list", { autoClose: 5000 });
        }
      } catch (error) {
        console.error("Error blocking user:", error);
        toast.error("Failed to add user to fraud detection list", { autoClose: 5000 });
      }
  
      // Continue with transaction approval
      try {
        const create = await createRecon(token, transaction);
        setTransactions((prevTransactions) => {
          const updatedTransactions = [...prevTransactions];
          updatedTransactions[transactionIndex].approved = true;
          return updatedTransactions;
        });
  
        const msg = create.Message;
        if (create.Status == "200") {
          toast("Chargeback Already Exists", { autoClose: 5000 });
        } else if (create.Status == "000") {
          toast.success("Chargeback Initiated", { autoClose: 5000 });
        }
      } catch (error) {
        console.error("Error in createRecon:", error);
        toast.error("Failed to approve transaction. Please try again.", { autoClose: 5000 });
      }
    } catch (error) {
      console.error("Error approving transaction:", error);
      toast.error("Failed to approve transaction. Please try again.", { autoClose: 5000 });
    }
  };
  
  

  const handleApproveAll = async () => {
    for (let i = 0; i < transactions.length; i++) {
      if (!transactions[i].approved) {
        await approveTransaction(i);
      }
    }
  };

  return (
    <div className="selected-transactions-container">
      <div className="selected-transactions-header">
        <h2>Selected Transactions</h2>
        <DownloadExcel transactions={transactions} fileName="Chargeback"/>
        <button className="btn green1" onClick={handleApproveAll}>
          Approve All
        </button>
      </div>
      {transactions.length === 0 ? (
        <p>No transactions selected.</p>
      ) : (
        transactions.map((transaction, index) => {
          const dateString = transaction.createdAt;
          const date = new Date(dateString);
          const day = date.getDate();
          const month = date.getMonth() + 1; // Months are 0-based
          const year = date.getFullYear();
          const hours = date.getHours();
          const minutes = date.getMinutes().toString().padStart(2, "0");
          const seconds = date.getSeconds().toString().padStart(2, "0");
          const formattedDate = `${day}-${month}-${year}`;
          const formattedTime = `${hours}:${minutes}:${seconds}`;

          return (
            <div className="transaction-box" key={index}>
              <div className="transaction-info">
                <h3>Transaction Details</h3>
                <ul>
                  <li>Name: {transaction.dataItem.customerName}</li>
                  <li>Amount: {transaction.requestAmount|| "N/A"}</li>
                  <li>Status: {transaction.responseData.RESPONSE_STATUS}</li>
                  <li>Date: {formattedDate}</li>
                  <li>Time: {formattedTime}</li>
                  <li>Mobile No: {transaction.dataItem.customerMobile}</li>
                </ul>
              </div>
              <div className="transaction-buttons">
                {transaction.approved ? (
                  <button className="btn green1">Approved</button>
                ) : (
                  <button
                    className="btn green1"
                    onClick={() => approveTransaction(index)}
                  >
                    Approve
                  </button>
                )}
                {!transaction.approved && (
                  <button className="btn red1">Reject</button>
                )}
              </div>
            </div>
          );
        })
      )}
    </div>
  );
};

export default SelectedTransactions;
